import React, { useEffect } from "react";
import "./style.css";

import NavBar from "./NavBar";
import HeroSection from "./HeroSection";
import FeaturesSection from "./FeaturesSection";
import SpecsSection from "./SpecsSection";
import EngineeredFeatures from "./EngineeredFeatures";
import VariantsSection from "./VariantsSection";
import UseCasesSection from "./UseCasesSection";
import { ProofBand, CTASection, Footer } from "./BottomSections";



export default function MiniDCChargerPage() {
  // Scroll reveal
  useEffect(() => {
    const reveals = document.querySelectorAll(".reveal");
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e, i) => {
          if (e.isIntersecting) {
            setTimeout(() => e.target.classList.add("visible"), i * 60);
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.08 }
    );
    reveals.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  // Nav active link highlight
  useEffect(() => {
    const sections = document.querySelectorAll("section[id]");
    const navLinks = document.querySelectorAll('.nav-links a[href^="#"]');
    const handleScroll = () => {
      let current = "";
      sections.forEach((sec) => {
        if (window.scrollY >= sec.offsetTop - 80) current = sec.id;
      });
      navLinks.forEach((a) => {
        a.style.color =
          a.getAttribute("href") === "#" + current ? "var(--green)" : "";
      });
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

return (
  <div className="mini-dc-page">
    <NavBar />
    <HeroSection />
    <FeaturesSection />
    <SpecsSection />
    <EngineeredFeatures />
    <VariantsSection />
    <UseCasesSection />
    <ProofBand />
    <CTASection />
  </div>
);
}
